export default __webpack_public_path__ + "static/media/K.9b52af72.png";